export default __webpack_public_path__ + "static/media/Punto_05_Scali_Rosciano_FRA_Def.0c46ec6d.aac";